import Vue from 'vue'
import JsonApiObject from '@/_models/JsonApi'

import WatchCategoryModel from '@/views/Watcher/models/watchCategory'
import WatcherModel from './watcher'

export default class WatchableResourceModel extends JsonApiObject {
    public constructor(data: any, included?) {
        super(data, included)
    }

    canModifyOtherWatchers

    get watchers(): Array<WatcherModel> {
        return this._relationships['user'] ? this._relationships['user'] : []
    }

    get optionalCategories(): Array<WatchCategoryModel> {
        return this._relationships['optionalCategories']
            ? this._relationships['optionalCategories']
            : []
    }

    static async get(
        watchableResourceId: string,
        include = ['watchers.user', 'optionalCategories']
    ) {
        let query = {
            include: include,
        }
        let res = await Vue.prototype.$vbit.get(
            'watcher',
            `watchableResource/${watchableResourceId}`,
            query
        )
        return new WatchableResourceModel(res.data, res.included)
    }
}
